// SHOP — the storefront. CR-7: Mao Coin packs are the ONLY real-money product
// (USD buys coin at the $1 = 1,000,000m peg; no subscription, no cash-out).
// Buying opens Stripe Checkout. Coins are added only AFTER Stripe confirms payment (see main.js settleCoinPurchases).
// Without Stripe configured, only a local dev build can grant test coin; production never does.

import { CoinPacks } from '../../config/balance.js'
import { buyCoins, getAccountInfo, manualPush, getBillingStatus } from '../../game/accountManager.js'
import { earnWealth } from '../../game/seasonManager.js'
import { formatCoins, formatUsd } from '../format.js'
import { Events, emit, on } from '../eventBus.js'

const COMING_SOON = [
  { title: 'SWAG', desc: 'Apparel and printed merch for the kingdom.' },
  { title: 'NFTC LAND', desc: 'Virtual parcels within your kingdom\'s territory.' },
  { title: 'NFTC ASSETS', desc: 'Jewels, homes, and weapons you can equip on your Mao.' },
]

export function mountShopPage({ root }) {
  const render = () => {
    root.innerHTML = `
      <div class="page-stub shop-page">
        <h1>Shop</h1>
        <p class="page-stub-sub">Buy Mao Coin to fast-track your rise. One currency, one-time purchases — no subscriptions, no cash-out.</p>

        <div class="shop-packs">
          ${CoinPacks.map(packCard).join('')}
        </div>
        <div class="shop-peg-note">Pegged at <strong>$1 = 1,000,000m</strong>. Coins are spent in-game on land, citizens, buildings, and degrees.</div>
        <div class="shop-mode" data-shop-mode hidden></div>
        <div class="shop-msg" data-shop-msg></div>

        <div class="page-stub-grid" style="margin-top:28px">
          ${COMING_SOON.map((s) => `
            <div class="page-stub-card">
              <div class="page-stub-card-title">${s.title}</div>
              <p>${s.desc}</p>
              <div class="page-stub-card-status">Coming soon</div>
            </div>
          `).join('')}
        </div>
      </div>
    `

    const msg = root.querySelector('[data-shop-msg]')
    const setMsg = (t, ok = false) => { msg.textContent = t || ''; msg.classList.toggle('ok', ok) }

    root.querySelectorAll('[data-buy-pack]').forEach((btn) => {
      btn.addEventListener('click', () => purchase(btn.dataset.buyPack, btn, setMsg))
    })
  }

  async function purchase(packId, btn, setMsg) {
    const pack = CoinPacks.find((p) => p.id === packId)
    if (!pack) return
    if (!getAccountInfo().loggedIn) {
      setMsg('Log in or adopt a Mao first to buy coin.')
      emit(Events.OpenLogin)
      return
    }
    btn.disabled = true
    setMsg('Redirecting to secure checkout…')
    const res = await buyCoins(packId)
    if (res.ok && res.url) {
      // Same-tab redirect to Stripe; on success it returns to the app with
      // ?coins=success&session_id=… which main.js confirms + credits.
      window.location.assign(res.url)
      return
    }
    if (res.notConfigured && !import.meta.env?.DEV) {
      // Production with payments not set up: NEVER hand out coins. (A free-grant fallback used to run here in every build.)
      setMsg('Purchases are not open yet. Please check back soon.')
      btn.disabled = false
      return
    }
    if (res.notConfigured) {
      // Local development only (Vite dev server): no Stripe wired → grant the coin directly so the flow can be tested.
      const total = pack.coins + (pack.bonus || 0)
      earnWealth(total)
      try { await manualPush() } catch { /* sync ticker retries */ }
      setMsg(`✓ Added ${formatCoins(total)} to your treasury (test grant — Stripe not configured).`, true)
      btn.disabled = false
      return
    }
    setMsg(res.reason === 'offline' ? 'You appear to be offline.' : 'Could not start checkout — try again.')
    btn.disabled = false
  }

  // Show a clear banner while Stripe is in TEST mode (no real charges), and turn the buy buttons off if payments are off.
  let billing = null
  const applyBilling = () => {
    const el = root.querySelector('[data-shop-mode]')
    if (!el || !billing) return
    if (billing.mode === 'test') { el.hidden = false; el.textContent = 'TEST MODE — no real money is charged. Use card 4242 4242 4242 4242, any future date, any CVC.' }
    else if (!billing.configured && !import.meta.env?.DEV) { el.hidden = false; el.textContent = 'Purchases are not open yet.'; root.querySelectorAll('[data-buy-pack]').forEach((b) => { b.disabled = true }) }
  }
  getBillingStatus().then((st) => { billing = st; applyBilling() })

  const renderAndApply = () => { render(); applyBilling() }
  renderAndApply()
  // Re-render so the login state (and thus button copy) stays current.
  on(Events.AccountReady, renderAndApply)
  on(Events.PageChange, renderAndApply)
}

function packCard(pack) {
  const total = pack.coins + (pack.bonus || 0)
  const bonusLine = pack.bonus
    ? `<div class="shop-pack-bonus">+ ${formatCoins(pack.bonus)} bonus</div>`
    : '<div class="shop-pack-bonus">&nbsp;</div>'
  return `
    <div class="shop-pack${pack.best ? ' best' : ''}">
      ${pack.best ? '<div class="shop-pack-flag">BEST VALUE</div>' : ''}
      <div class="shop-pack-label">${pack.label}</div>
      <div class="shop-pack-coins">${formatCoins(total)}</div>
      ${bonusLine}
      <button class="shop-pack-buy" data-buy-pack="${pack.id}">${formatUsd(pack.priceUsd)}</button>
    </div>
  `
}
